import BasicLayout from "@main/layouts/BasicLayout/index.vue";
import { createRouter, createWebHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import setupGuards from "./guards";
import { menuRoutes } from "./menuRoutes";

// 静态路由：登录和404页面始终可用
const staticRoutes: RouteRecordRaw[] = [
	{
		path: "/login",
		name: "Login",
		meta: {
			title: "登录",
		},
		component: () => import("@main/views/Login/LoginPage.vue"),
	},
	{
		path: "/noPermission",
		name: "NoPermission",
		meta: {
			title: "无权限访问",
		},
		component: () => import("@main/views/NoPermission.vue"),
	},
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: () => import("@main/views/NoMatch.vue"),
	},
];

// 动态路由的根路由，将在后续动态添加子路由
const getRootRoute = (children: RouteRecordRaw[] = []): RouteRecordRaw => ({
	path: "/",
	name: "Root",
	component: BasicLayout,
	redirect: "/desktopCenter",
	children,
});

// 初始路由：包含登录、404和空的根路由
const getInitialRoutes = (): RouteRecordRaw[] => [getRootRoute([...menuRoutes]), ...staticRoutes];

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: getInitialRoutes(),
});

setupGuards(router);

export default router;
